import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, ChevronRight } from 'lucide-react';
import { useCart } from '../../lib/cart';
import { useLanguage } from '../../lib/i18n';
import { formatCurrency, cn } from '../../lib/utils';
interface FloatingCartButtonProps {
  primaryColor?: string;
  className?: string;
}
export function FloatingCartButton({
  primaryColor = '#F59E0B',
  className
}: FloatingCartButtonProps) {
  const {
    getItemCount,
    getTotal
  } = useCart();
  const {
    t
  } = useLanguage();
  const count = getItemCount();
  const total = getTotal();
  if (count === 0) return null;
  return <div className={cn('fixed bottom-6 left-0 right-0 z-40 px-4 sm:px-6 lg:px-8 pointer-events-none', className)} data-id="element-1139">
      <div className="max-w-5xl mx-auto flex justify-center sm:justify-end" data-id="element-1140">
        <Link to="/cart" className="pointer-events-auto flex items-center justify-between w-full sm:w-auto min-w-[320px] bg-brand-charcoal text-white rounded-2xl p-4 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 group" data-id="element-1141">
          <div className="flex items-center gap-3" data-id="element-1142">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{
            backgroundColor: primaryColor
          }} data-id="element-1143">
              <ShoppingBag className="w-5 h-5 text-white" data-id="element-1144" />
            </div>
            <div className="flex flex-col" data-id="element-1145">
              <span className="font-semibold text-sm text-gray-300" data-id="element-1146">
                {t('view_order')}
              </span>
              <span className="font-bold text-lg leading-none" data-id="element-1147">
                {count} {count === 1 ? t('product') : t('products')}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-1148">
            <span className="font-bold text-xl" data-id="element-1149">{formatCurrency(total)}</span>
            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors group-hover:translate-x-1" data-id="element-1150" />
          </div>
        </Link>
      </div>
    </div>;
}